import React from 'react';
import InfoContainer from "./container/InfoContainer";
import { Translation } from 'react-i18next';
import styles from './badges.module.css';
import { CDN_URI as MAIN_CDN_URI } from '../common/utilities';
import clsx from 'clsx';


export default class BadgeLevels extends React.Component{

    /*    
    * createBadge
    * @param {string} level ['RUSH_LEV', 'ELITE_LEV', 'SPECIAL_LEV', 'SCOUTING_LEV', 'SNIPER_LEV']
    * @param {INT} count (0-9)
    * @returns {string}

        Example Return String of Composite Badge 

            <img src="https://crossfire.akamaized.net/cfna/templates/assets/imgs/badges_na/C_classBG.png">
            <img src="https://crossfire.akamaized.net/cfna/templates/assets/imgs/badges_na/assault_C_class.png">
            <img src="https://crossfire.akamaized.net/cfna/templates/assets/imgs/badges_na/3_level.png">

    */
    createBadge (level, count) {

        count = (typeof count !== 'undefined') && '' !== count && (parseInt(count, 10) >= 0 &&  parseInt(count, 10) < 10) ? parseInt(count, 10) : 0;

        // var CDN_URI = `${MAIN_CDN_URI}imgs/${window._region === 'BR' ? 'badges_br' : 'badges_na/'}`;
        var CDN_URI = `${MAIN_CDN_URI}imgs/badges_na/`;

        var bg_img, class_img, badge = '';
        var disable_view_img = 'disable_cover.png';
        var bg_img_suffix = '_classBG.png';
        var class_img_suffix = '_class.png';
        var level_img_suffix = '_level.png';

        /*
        // this is how column name maps to image name
            SNIPER_LEV = sniper
            RUSH_LEV = assassin
            SCOUTING_LEV = scout
            ELITE_LEV = elite
            SPECIAL_LEV = knife			
        */

        switch (level){
            case 'RUSH_LEV' : badge = 'assault'; break;  // badge = 'a'
            case 'ELITE_LEV' : badge = 'elite'; break;    // badge = 'b'
            case 'SPECIAL_LEV' : badge = 'knife'; break;    // badge = 'c'
            case 'SCOUTING_LEV' : badge = 'scout'; break;    // badge = 'd'
            case 'SNIPER_LEV' : badge = 'sniper'; break;   // badge = 'e'
        }			

        var level_bar = (0 === count) ? 1 : (0 === (count % 3)) ? 3 : count % 3;

        // the background image and class image are based on the player's badge count

        switch (count){
            case 0 :
            case 1 :
            case 2 :
            case 3 : bg_img = 'C'; class_img = 'C'; break; //class_img = 'A'; break;
            case 4 :
            case 5 :
            case 6 : bg_img = 'B'; class_img = 'B'; break;
            case 7 :
            case 8 :
            case 9 : bg_img = 'A'; class_img = 'A'; break; //class_img = 'C'; break;
        }

        var imgline = '<img src="' + CDN_URI + bg_img + bg_img_suffix + '" alt="bg">'
                        + '<img src="' + CDN_URI + badge + '_' + class_img + class_img_suffix + '" alt="class">';

        // add disable_view or level image
        if(0 === count){
            imgline += '<img src="' + CDN_URI + disable_view_img + '" alt="level">';
        }else{
            imgline += '<img src="' + CDN_URI + level_bar + level_img_suffix + '" alt="level">';
        }
        return imgline;
    }

    showInt(count = 0 ){
        return (typeof count !== 'undefined') && '' !== count && (parseInt(count, 10) >= 0 &&  parseInt(count, 10) < 10) ? parseInt(count, 10) : 0;
    }

    render (){

        return (
            <Translation>
            {
            (t) => 
            <InfoContainer 
            headerLeft={t("Badges")} 
            headerRight={null} 
            height='100%'
            footer=''
          >
            <div className={styles.badges}>
                <div className={styles.row}>
                    <h5>
                        <div className={clsx(styles.badge_img, window._region === 'BR' && styles.br)}>
                            <div className={styles.sgw_layered_badge} 
                                dangerouslySetInnerHTML={{ __html: this.createBadge ('RUSH_LEV', this.props.RUSH_LEV) }}
                            ></div>
                        </div>
                        {t('Soldier Badge')}
                    </h5>
                    <h3>{ this.showInt(this.props.RUSH_LEV) }</h3>
                </div>

                <div className={styles.row}>
                    <h5>
                        <div className={clsx(styles.badge_img, window._region === 'BR' && styles.br)}>
                            <div className={styles.sgw_layered_badge} 
                                dangerouslySetInnerHTML={{ __html: this.createBadge ('ELITE_LEV', this.props.ELITE_LEV) }}
                            ></div>
                        </div>
                        {t('Elite Badge')}
                    </h5>
                    <h3>{ this.showInt(this.props.ELITE_LEV) }</h3>
                </div>

                <div className={styles.row}>
                    <h5>
                        <div className={clsx(styles.badge_img, window._region === 'BR' && styles.br)}>
                            <div className={styles.sgw_layered_badge} 
                                dangerouslySetInnerHTML={{ __html: this.createBadge ('SPECIAL_LEV', this.props.SPECIAL_LEV) }}
                            ></div>
                        </div>
                        {t('Assassin Badge')}
                    </h5>
                    <h3>{ this.showInt(this.props.SPECIAL_LEV) }</h3>
                </div>

                <div className={styles.row}>
                    <h5>
                        <div className={clsx(styles.badge_img, window._region === 'BR' && styles.br)}>
                            <div className={styles.sgw_layered_badge} 
                                dangerouslySetInnerHTML={{ __html: this.createBadge ('SCOUTING_LEV', this.props.SCOUTING_LEV) }}
                            ></div>
                        </div>
                        {t('Scouting Badge')}
                    </h5>
                    <h3>{ this.showInt(this.props.SCOUTING_LEV) }</h3>
                </div>            

                <div className={styles.row}>
                    <h5>
                        <div className={clsx(styles.badge_img, window._region === 'BR' && styles.br)}>
                            <div className={styles.sgw_layered_badge} 
                                dangerouslySetInnerHTML={{ __html: this.createBadge ('SNIPER_LEV', this.props.SNIPER_LEV) }}
                            ></div>
                        </div>
                        {t('Sniper Badge')}
                    </h5>
                    <h3>{ this.showInt(this.props.SNIPER_LEV) }</h3>
                </div>
            </div>
            </InfoContainer>
            }
            </Translation>

        );
    }
}